export const extractDomain = (url: string) => {
  const regex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)/gim;
  const result = regex.exec(url);
  if (!result) return null;
  return result[0];
};
